export { default } from "bullitttime-embermodelsevent/models/start-timing-record";
